// extracted by mini-css-extract-plugin
export default {"messageCard":"NoItems10Basket_messageCard__EyAYU","cardBackground":"NoItems10Basket_cardBackground__KnOpj","messageContent":"NoItems10Basket_messageContent__OZBpW"};